import styled from '@emotion/styled'

const StyledList = styled.nav`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 8px 0;
`

export { StyledList as List }
